import storeInfo from 'ducks/store'
import { CampaignsType } from './types'

export const getCampaigns = () => (): any => {
  const { campaigns } = storeInfo.store.getState()
  // if (!orderMaintenance) return null
  return campaigns
}
